import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { OnboardingAction } from '../models';
import { Coverage3dOnboardingDeviceBehaviorService } from '../services';

@Pipe({ name: 'onboardingActionDescription', standalone: true })
export class OnboardingActionDescriptionPipe implements PipeTransform {
	private readonly transloco = inject(TranslocoService);
	private readonly deviceBehavior = inject(Coverage3dOnboardingDeviceBehaviorService);

	public transform(action: OnboardingAction, model: DeviceModel): string {
		// Prioritize the device-specific description if available
		const description = this.deviceBehavior.getActionDescription(model, action);
		if (description) {
			return description;
		}

		// Apply default descriptions based on the action if no device-specific description is available
		switch (action) {
			case OnboardingAction.SceneDrag:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-actions.scene-click-and-drag.description'
				);
			case OnboardingAction.SceneScroll:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-actions.scene-scroll.description');
			case OnboardingAction.LobeAdd:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-actions.lobe-add.description');
			case OnboardingAction.LobeClickAndDrag:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-actions.lobe-click-and-drag.description'
				);
			case OnboardingAction.LobeMultiSelect:
				return this.transloco.translate(
					'scCoverage3dOnboarding.onboarding-actions.lobe-multi-select.description'
				);
			case OnboardingAction.LobeSnap:
				return this.transloco.translate('scCoverage3dOnboarding.onboarding-actions.lobe-snap.description');
			default:
				return '';
		}
	}
}
